// Shared custom DOM event names for "the logged-in trainer's own profile changed" — kept in
// their own leaf module (no component imports) so both AppShell (listener) and Settings
// (dispatcher) can import it without creating a circular dependency between them.
export const PROFILE_UPDATED_EVENT = "hf-employee-profile-updated";
